'use strict';

var app = angular.module('app');

// Service to load the phpVariables from server to client.
app.factory('siteVariablesService', function () {
    return {
        getVariables: function () {
            if(typeof phpVariables !== 'undefined'){
                return phpVariables
            }else{
               return null
            }
        }
    }
});